import {
    Component,
    Directive,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import {
    HeatmapComboboxComponent
} from "@app/netscope/netscope-heatmap-viewer/heatmap-combobox/heatmap-combobox.component";
import {
    of
} from "rxjs";
import {
    NetscopeResource,
    ResourceWithSide,
    SharedFilterOptions
} from "@app/netscope/netscope-flows-datagrid/netscope-flows-datagrid.component";
import {FlowRepositorySearch, FlowsRepository} from "@app/netscope/model/flows-repository";
import Fuse from "fuse.js";
import {NetscopeUtils} from "@app/netscope/netscope-utils";
import {FlowRessourceObject} from "@app/netscope/model/data-models";


@Component({
    standalone: false,
    selector: 'resource-filter',
    templateUrl: './resource-filter.component.html',
    styleUrls: ['./resource-filter.component.css']
})
export class ResourceFilterComponent implements OnInit {

    options;
    @Input()
    label;

    @Input()
    side = "source";

    @Input()
    items: any[];

    @Input()
    flowsRepository: FlowsRepository;

    @Input()
    sharedOptions: SharedFilterOptions = new SharedFilterOptions();

    @Input()
    tableUpdate: EventEmitter < any > ;

    allResources = [];

    selected;
    displayedSelectedResources: any[] = [];
    selectedResources: ResourceWithSide[] = [];

    changes: any = new EventEmitter < any > (false);

    uuid: string = NetscopeUtils.generateUuid();

    search: FlowRepositorySearch;

    manualRefresh: EventEmitter < void > = new EventEmitter < void > ();

    disableEventPropagation = () => {
        setTimeout(() => {
            // @ts-ignore
            for (let element of document.getElementsByClassName("clr-combobox-options")) {
                element.onclick = (event) => {
                    event.stopPropagation();
                }
            }
        }, 200);
    }

    ngOnInit() {
        this.initFilter();

        // If table config is not dynamic, there is no need to provide an event emitter
        if (this.tableUpdate != undefined) {
            this.tableUpdate.subscribe(items => {
                this.items = items;
                this.initFilter();
                this.manualRefresh.emit();
            });
        }
    }

    initFilter = async () => {
        this.search = new FlowRepositorySearch(this.flowsRepository, []);
        await this.search.init([this.side], ["focus"]);
    }

    triggerEvent() {
        this.updateFilterInDatagrid();
        this.changes.emit(true);
    }

    fetchResources = (filter = '', combobox: HeatmapComboboxComponent) => {
        combobox.loadingResources = true;

        let simpleResults = this.search.search(filter);
        let resources = simpleResults.map((r) => r.resource);

        combobox.asyncResources$ = of(resources);
        combobox.loadingResources = false;
    }

    accepts(item: any) {
        let selectedResourceIndex = {};
        for (let resource of this.sharedOptions.selectedResources) {
            selectedResourceIndex[resource.resource.uuid] = resource;
        }

        if (this.isActive() && this.sharedOptions.selectedResources.length > 0) {

            for (let resourceSide of [{
                    resource: item.source,
                    side: "source"
                }, {
                    resource: item.target,
                    side: "destination"
                }]) {
                if (resourceSide.resource !== undefined && resourceSide.resource.uuid !== undefined &&
                    selectedResourceIndex[resourceSide.resource.uuid] !== undefined) {
                    let resourceWithSide = selectedResourceIndex[resourceSide.resource.uuid];

                    if (resourceWithSide.side === "source or destination" || resourceWithSide.side === resourceSide.side) {
                        return true;
                    }
                }
            }

            return false;
        } else {
            return true;
        }
    }

    removeResource = (resource) => {
        this.sharedOptions.selectedResources = this.sharedOptions.selectedResources.filter((otherResource) =>
            resource.uuid !== otherResource.resource.uuid);

        if (this.sharedOptions.selectedResources.length === 0) {
            this.sharedOptions.filterIsActive = false;
        }

        this.triggerEvent();
    }

    toggleSide = (resourceWithSide: ResourceWithSide) => {
        if (resourceWithSide.side === "source") {
            resourceWithSide.side = "destination";
        } else {
            if (resourceWithSide.side === "destination") {
                resourceWithSide.side = "source or destination";
            } else {
                resourceWithSide.side = "source";
            }
        }

        this.triggerEvent();
    }

    resourceSelectionChanged = (event) => {
        let newResourcesWithSide: ResourceWithSide[] = event.model.map((resource) => {
            let result = new ResourceWithSide();
            result.side = this.side;
            result.resource = resource;
            return result;
        });
        this.sharedOptions.selectedResources.push(...newResourcesWithSide);
        event.model = [];
        this.triggerEvent();
    }

    updateFilterInDatagrid = () => {
      let filterAsSqlExpression = "true";

      if (this.sharedOptions.selectedResources.length > 0) {
        let resourcesAsWhereExpression = [];

        for (let item of this.sharedOptions.selectedResources) {
          let currentExpressionsParts = ["false"];
          if (item.side == "source" || item.side == "source or destination") {
            currentExpressionsParts.push(` src_resource_uuid = '${item.resource.uuid}' `);
          }
          if (item.side == "destination" || item.side == "source or destination") {
            currentExpressionsParts.push(` dst_resource_uuid = '${item.resource.uuid}' `);
          }

          let combinedExpression = currentExpressionsParts.join(" or ");
          let combinedExpressionWithParenthesis = ` (${combinedExpression}) `;
          resourcesAsWhereExpression.push(combinedExpressionWithParenthesis);
        }
        filterAsSqlExpression = resourcesAsWhereExpression.join(" or ");
      }

      this.flowsRepository.datagridFilterMap.set("resource", filterAsSqlExpression);
    }

    isActive(): boolean {
        if (this.sharedOptions === undefined) {
            return false;
        }
        return this.sharedOptions.selectedResources.length > 0;
    }
}

